import React, { useRef, useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function RevealSection({
  children,
  className = '',
  direction = 'up', // 'up' | 'left' | 'right' | 'scale'
  duration = 1,
  delay = 0,
  triggerStart = 'top 85%',
}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const fromVars = { opacity: 0 };
    const toVars = { opacity: 1, duration, delay, ease: 'power3.out' };

    switch (direction) {
      case 'up':
        fromVars.y = 60;
        toVars.y = 0;
        break;
      case 'left':
        fromVars.x = -60;
        toVars.x = 0;
        break;
      case 'right':
        fromVars.x = 60;
        toVars.x = 0;
        break;
      case 'scale':
        fromVars.scale = 0.9;
        toVars.scale = 1;
        break;
      default:
        fromVars.y = 60;
        toVars.y = 0;
    }

    gsap.set(el, fromVars);

    const tween = gsap.to(el, {
      ...toVars,
      scrollTrigger: {
        trigger: el,
        start: triggerStart,
        toggleActions: 'play none none none',
      },
    });

    return () => {
      tween.kill();
    };
  }, [direction, duration, delay, triggerStart]);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}
